<div class="grid-x">
  <div class="cell large-12 medium-12 small-12 bold">
    <div class="section-header" [ngClass]="{ 'active' : step == activeStep }" (click)="toggleOpen()">
      <span class="margin-right">Step 6: Well Site Access</span>
      <button class="icon-button">
        @if (isOpen == false) {
          <svg-icon icon="icon-caret-right"></svg-icon>
        }
        @if (isOpen == true) {
          <svg-icon icon="icon-caret-down"></svg-icon>
        }
      </button>
    </div>
  </div>
</div>
<div class="grid-x margin-top" [formGroup]="form" [ngClass]="{ 'hideSection': isOpen == false }">
  <div class="cell large-4 medium-4 small-4 text-align-right padding-right bold">
    Describe Ingress / Egress Route<span [ngClass]="{ 'red': form?.get('description')?.invalid }">*</span>:
    @if (fieldHasNotes('access|description') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'access|description'" [notes]="getFilteredNotes('access|description')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-8 medium-8 small-8">
    <textarea formControlName="description"></textarea>
  </div>
  <div class="cell large-12 medium-12 small-12 bold text-align-center">
    Location (NAD83) of Well Site Entrance from a Public Road:
  </div>
  <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
    <help-text [helpText]="coordinateHelpText"></help-text><span class="padding-left">Latitude:</span>
    @if (fieldHasNotes('access|latitude') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'access|latitude'" [notes]="getFilteredNotes('access|latitude')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="number" formControlName="latitude" step="0.000001" (blur)="roundCoordinate('latitude')" />
  </div>
  <div class="cell large-3 medium-3 small-6 text-align-right padding-right bold">
    <help-text [helpText]="coordinateHelpText"></help-text><span class="padding-left">Longitude:</span>
    @if (fieldHasNotes('access|longitude') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'access|longitude'" [notes]="getFilteredNotes('access|longitude')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <input type="number" formControlName="longitude" (blur)="roundCoordinate('longitude')" />
  </div>
</div>